module.exports = __webpack_public_path__ + "img/number_3.3e3a6ef2.png";